<template>
<div id="main-div">
  <div class="loader d-none">
    <!-- <img src="./assets/loadding.gif" alt=""> -->
  </div>
  <div v-if="timeMsg == ''">
    <div class="root-app desktop">
      <div>
        <div class="layout-header">
          <!-- <img class="gcashLogo" src="../assets/gcashLogo.png" alt=""> -->
        </div>
        <div class="layout-content">
          <div id="step1" class="main-container login-page warp2">
            <div class="merchant-info">
              <!-- <div class="row"><label style="font-size:18px">Merchant</label> <span style="font-size:18px" class="merchant-name">GCPay, Inc.</span></div>
              <div class="row"><label style="font-size:18px">Amount Due</label> <span style="font-size:18px" class="amount">PHP <span class="showAmount">{{ order.amount }}</span></span></div> -->
            </div>
            <input type="hidden" name="m_id" value="2962540331787">
            <div class="page-container">
              <div class="page-main content-center">
                <p class="mb-0 loginInfo">이름을 입력하세요.</p>
                <div class="login pt-0">
                  <div accessbilityid="mobile-input" class="m-input hasPrefix
                      notEmpty" autofocus="autofocus">
                    <div class="input-wrap">
                      <label class="placeholder mb-0">성함 입력하십시오</label>
                      <div class="d-flex">
                        <!-- <div class="input-prefix">+82</div> -->
                        <!-- <input v-model="user_name"  type="text" class="phone" name="mobileNum"> -->
                        <input v-model="user_name" type="text" class="phone" name="mobileNum" @input="restrictToKorean">
                        <!-- <div class="line"></div> -->
                      </div>
                    </div>
                    <p class="error-text error-message"></p>
                  </div>
                </div>
              </div>
              <footer>
                <div class="submit-button display-mobile">
                  <button :disabled="disabledBtn" @click="sendOrder" type="submit" class="ap-button ap-button-primary" accessbilityid="next-button">
                    NEXT
                  </button>
                </div>
                <p style="color:black;font-size: 16px;margin-bottom:0px;margin:0 auto;text-align:left;font-weight: bold; margin-top:15px;max-width: 90%;   width: 5.92rem">
                  주의사항:
                </p>
                <p style="color:black;font-size: 16px;margin-bottom:0px;margin:0 auto;text-align:left;font-weight: bold;max-width: 90%; width: 5.92rem;">이름을 입력하세요. 입금자 이름과 일치해야 합니다. 잘못된 입력은 자동으로 입금되지 않을 수 있습니다.</p>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-column justify-content-start align-items-center" v-if="timeMsg == ''">
  </div>
  <div v-else class="timeMsg text-center pt-4">
    <h4 class="tit1 text-center" style="color:#007bff !important">{{timeMsg}}</h4>
  </div>
</div>
</template>

<style lang="scss" scoped>
.m-message-container.is-top-center {
  z-index: 9999 !important;
}

.m-message {
  z-index: 9999 !important;
}

.m-message-container {
  z-index: 9999 !important;
}

.allWrap {
  // background-color: #fff;
}

.alertWrap {
  position: fixed;
  z-index: 90;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .alert {
    width: 345px;
    box-shadow: 0 0 3px 3px rgba(0, 0, 0, .6);
    height: 345px;
    background-color: white;
    border-radius: 5px;
  }
}
</style>

<script>
import axios from "axios";
import 'video.js/dist/video-js.css'
import {
  videoPlayer
} from 'vue-video-player'
export default {
  components: {
    videoPlayer
  },
  data() {
    return {
      videoModal: false,
      order: "",
      timeout: "",
      timeMsg: "",
      showAlert: true,
      user_name: "",
      playerOptions: {
        // videojs options
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/gcashMoive.mp4"
        }],
      }
    };
  },
  computed: {
    disabledBtn() {
      return this.$store.state.isLoading
    }
  },
  methods: { 
    restrictToKorean() {
      const koreanRegex = /[가-힣]/g;
      this.user_name = this.user_name.match(koreanRegex)?.join('') || '';
    },
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}/aaa/query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          let code = res.data.code;
          let type = {
            '20005': 'The order is not exists', // The order is not exists.
            '20012': "The order is expired.", //  The order is not expired.
            '20013': "Something went wrong, contact us please.", // Something went wrong, contact us please.
            '20000': "Something went wrong, contact us please.", // Something went wrong, contact us please.
            '20014': "The order is completed.", // The order is completed.
          }
          if (res.data.code == 0) {
            this.order = res.data.data;
            if (res.data.data.user_name && res.data.data.view_url && res.data.data.view_url.indexOf(location.origin) == -1) {
              location.href = res.data.data.view_url
            }
          } else {
            this.$message({
              type: 'error',
              message: type[code],
              closable: true
            })
            this.timeMsg = type[code];
            this.showAlert = false
            clearInterval(this.timeout);
          }
        });
    },
    sendOrder() {
      let user_name = this.user_name;
      if (!this.user_name.length) {
        return
      }

      this.disabledBtn = true;
      axios
        .post(
          `${process.env.VUE_APP_DEFAULT_SRC}/aaa/send?transaction_id=${this.$route.query.transaction_id}&user_name=${this.user_name}`, {
            transaction_id: this.$route.query.transaction_id,
            user_name
          }
        )
        .then(res => {
          this.disabledBtn = false;
          let code = res.data.code;
          let type = {
            '20005': 'The order is not exists', // The order is not exists.
            '20012': "The order is expired.", //  The order is not expired.
            '20013': "Something went wrong, contact us please.", // Something went wrong, contact us please.
            '20000': "Something went wrong, contact us please.", // Something went wrong, contact us please.
            '20014': "The order is completed.", // The order is completed.
          }
          if (code == 0) {
            window.location.href = res.data.data.view_url;
            this.order = res.data.data;
          } else {
            this.$message({
              type: 'error',
              message: type[code],
              closable: true
            })
            this.timeMsg = type[code];
            this.showAlert = false
          }
        }).catch(() => {
          this.disabledBtn = false;
        });
    }
  },
  updated() {
    document.title = 'GCash'
  },
  created() {
    var faviconurl = "/gcash-favicon.png";

    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');

    link.type = 'image/x-icon';

    link.rel = 'shortcut icon';

    link.href = faviconurl;

    document.getElementsByTagName('head')[0].appendChild(link);
    document.title = 'GCash'
    this.getOrder();
  }
};
</script>
<style>

html {
    font-size: 60px;
  }
  
    body {
      background-color: #ebecf0 !important;
    }
    html {
      background-color: #ebecf0 !important;
    }
  </style>
<style lang="scss" scoped>
.layout-header {
  height: 4.5rem;
  line-height: 2.6rem;
  font-size: .8rem;
  ;
  background: #0057e4;
  color: #fff;
  margin: 0;
  text-align: center;
}

#main-div {
  background-color: #ebecf0 !important;
}

.layout-content {
  margin: 0 auto 1em;
  max-width: 9rem;
}

.merchant-info {
  background: #f7f7f9 !important;
  padding: 0.32rem 0.56rem;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-pack: center;
  justify-content: center;
  color: #696b6d;
}

.main-container {
  margin-top: -130px;
  border-radius: 5px;
  overflow: hidden;
  background-color: white;
  padding-bottom: 40px;
}

.row {
  line-height: 55px;
  flex-wrap: nowrap;

  label {
    margin: 0px;
    width: 160px;
    color: #a3a9b7;
    text-align: left;
    font-weight: 600;
  }
}

.merchant-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -ms-flex-preferred-size: 57%;
  flex-basis: 57%;
  text-align: left;
  font-weight: bold;
  font-size: 22px;
}

.merchant-info .amount {
  color: #0057e4;
  font-weight: bold;
  font-weight: 18px;
}

.login {
  margin: 0.4rem 1.7rem 0;
}

.m-input {
  margin-bottom: 0.1rem;
}

.m-input .input-wrap {
  width: 100%;
  padding: 0.2rem 0.1rem 0.05rem;
  font-size: .4rem;
  border-bottom: 1px solid #d6d6d6;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.input-prefix {
  width: 0.8rem;
  color: #292b30;
  font-weight: bold;
}

.input-wrap input {
  position: relative;
  z-index: 2;
  -ms-flex: 1;
  flex: 1;
  color: #292b30;
  border: none;
  background: 0 0;
  outline: none;
  // margin-left: 0.5em;
  // border-left: 1px solid #d6d6d6;
  padding-left: 10px;
  font-weight: bold;
}

.placeholder {
  transform: translate(0);
  font-size: .3rem;
  color: #696b6d;
  line-height: 1.7;
  font-weight: bold;

}

// .line {
//     position: absolute;
//     bottom: -1px;
//     left: 50%;
//     transform: translatex(-50%) translateZ(0);
//     width: 0;
//     font-size: 0;
//     line-height: 0;
//     height: 1px;
//     background: #ff4848;
//     transition: width .5s;
// }
.ap-button {
  max-width: 90%;
  width: 5.92rem;
  height: 0.88rem;
  line-height: .88rem;
  border-radius: 0.5rem;
}

.submit-button .ap-button-primary {
  background-color: #0057e4;
}

.ap-button {
  display: block;
  // width: 100%;
  height: 0.8rem;
  margin: 0 auto;
  border: 0;
  // border-radius: 0.1rem;
  outline: none;
  font-size: .3rem;
  text-align: center;
  white-space: nowrap;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ap-button-primary {
  font-family: Karla, sans-serif !important;
  font-weight: 700 !important;
}

.ap-button-primary {
  background: #0f7efe;
  color: #fff;
}

.gcashLogo {
  width: 240px;
}

.loginInfo {
  color: black;
  font-size: 18px;
  font-weight: bold;
  margin-top: 15px
}

@media(max-width:768px) {
  .login {
    margin-left: 10px;
    margin-right: 10px;
  }

  .layout-content {
    max-width: 90%;
    width: 9rem;
  }

  .layout-header {
    height: 150px;
  }

  .main-container {
    margin-top: -80px;
  }

  .layout-header {
    line-height: unset;
  }

  .gcashLogo {
    width: 33%;
  }

  .merchant-info {
    padding-left: 46px;
  }

  .row {
    line-height: 36px;

    &:first-child {
      padding-bottom: 10px;
    }
  }

  .merchant-info label {
    width: 2.7rem;
  }

  .placeholder {
    font-size: 14px;
  }

  .input-prefix {}

  .loginInfo {
    font-size: 16px;
  }

  .login {
    margin: 0.4rem 0.5rem 0;
    margin-top: 10px;
  }

  .merchant-info label {
    width: 2.1rem;
  }

  .amount {
    font-weight: 500 !important;
  }
}
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none;
  margin: 0; 
}
input[type=number] {
    -moz-appearance:textfield;
}
</style>
